"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/toConsumableArray.js"));
require("core-js/modules/es6.array.sort");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("core-js/modules/es6.regexp.split");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es6.number.constructor");
require("core-js/modules/es6.function.name");
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
require("core-js/modules/es6.string.ends-with");
require("core-js/modules/es6.string.starts-with");
var _cipher = require("@/api/activity/cipher");
var _lottery = require("@/api/activity/lottery");
var _gradeInfo = require("@/api/basic/gradeInfo");
var _common = require("@/api/common");
var _shopList = require("@/api/shop/shopList");
var _popupConfig = require("@/api/popup/popupConfig");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// 参与地区“全国”选项值（region_id 均为正数，0 表示全国=不限地区，保存时落地为空）
var NATIONWIDE_ZONE = 0;

// 自定义图片上传组件
var ImageUpload = {
  name: 'ImageUpload',
  props: {
    value: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      fileList: [],
      uploading: false
    };
  },
  watch: {
    value: function value(val) {
      if (val && !this.fileList.length) {
        this.fileList = [{
          name: 'image',
          url: this.getDisplayUrl(val)
        }];
      } else if (!val) {
        this.fileList = [];
      }
    }
  },
  created: function created() {
    if (this.value) {
      this.fileList = [{
        name: 'image',
        url: this.getDisplayUrl(this.value)
      }];
    }
  },
  methods: {
    getDisplayUrl: function getDisplayUrl(path) {
      if (!path) return '';
      if (path.startsWith('http://') || path.startsWith('https://')) return path;
      var prefix = process.env.VUE_APP_IMAGE_PATH || '';
      if (!prefix) return path;
      var p = prefix.endsWith('/') ? prefix : prefix + '/';
      var v = path.startsWith('/') ? path.slice(1) : path;
      return p + v;
    },
    beforeUpload: function beforeUpload(file) {
      var isImage = file.type.startsWith('image/');
      var isLt2M = file.size / 1024 / 1024 < 2;
      if (!isImage) {
        this.$message.error('只能上传图片文件!');
        return false;
      }
      if (!isLt2M) {
        this.$message.error('图片大小不能超过 2MB!');
        return false;
      }
      return true;
    },
    uploadImage: function () {
      var _uploadImage = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee(file) {
        var loading, res, url, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              loading = this.$loading({
                lock: true,
                text: '上传中...',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
              });
              _context.prev = 1;
              _context.next = 2;
              return (0, _cipher.uploadCipherImage)(file);
            case 2:
              res = _context.sent;
              loading.close();
              url = res && res.data || res;
              if (url) {
                this.fileList = [{
                  name: file.name,
                  url: this.getDisplayUrl(url)
                }];
                this.$emit('input', url);
                this.$message.success('上传成功');
              } else {
                this.$message.error('上传失败');
                this.fileList = [];
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              loading.close();
              this.$message.error('上传失败：' + _t.message);
              this.fileList = [];
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3]]);
      }));
      function uploadImage(_x) {
        return _uploadImage.apply(this, arguments);
      }
      return uploadImage;
    }(),
    handleRemove: function handleRemove() {
      this.fileList = [];
      this.$emit('input', '');
    },
    handlePreview: function handlePreview() {
      if (this.fileList.length > 0) {
        window.open(this.fileList[0].url, '_blank');
      }
    }
  },
  render: function render(h) {
    var _this = this;
    var hasFile = this.fileList.length > 0;
    if (hasFile && !this.disabled) {
      return h('div', {
        class: 'image-upload-container',
        style: {
          position: 'relative',
          display: 'inline-block',
          width: '100px',
          height: '100px'
        }
      }, [h('img', {
        attrs: {
          src: this.fileList[0].url
        },
        style: {
          width: '100%',
          height: '100%',
          objectFit: 'cover',
          borderRadius: '6px',
          border: '1px solid #dcdfe6'
        },
        on: {
          click: this.handlePreview
        }
      }), h('i', {
        class: 'el-icon-close',
        style: {
          position: 'absolute',
          top: '-8px',
          right: '-8px',
          width: '20px',
          height: '20px',
          borderRadius: '50%',
          backgroundColor: '#909399',
          color: '#fff',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          cursor: 'pointer',
          fontSize: '12px',
          zIndex: 1
        },
        on: {
          click: this.handleRemove
        }
      })]);
    } else {
      var uploadButton = h('el-upload', {
        class: 'image-uploader',
        props: {
          'show-file-list': false,
          'before-upload': this.beforeUpload,
          'http-request': function httpRequest(options) {
            _this.uploadImage(options.file);
          },
          disabled: this.disabled
        }
      }, [h('div', {
        class: 'el-upload el-upload--text',
        style: {
          width: '100px',
          height: '100px',
          border: '1px dashed #d9d9d9',
          borderRadius: '6px',
          cursor: this.disabled ? 'not-allowed' : 'pointer',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          backgroundColor: '#fbfdff'
        }
      }, [h('i', {
        class: 'el-icon-plus',
        style: {
          fontSize: '28px',
          color: '#8c939d'
        }
      })])]);
      return h('div', {
        class: 'image-upload-container',
        style: {
          display: 'inline-block'
        }
      }, [uploadButton]);
    }
  }
};
var _default = exports.default = {
  name: 'CipherConfigPane',
  components: {
    ImageUpload: ImageUpload
  },
  props: {
    id: {
      type: Number,
      default: null
    }
  },
  data: function data() {
    return {
      loading: false,
      timeRange: [],
      gradeOptions: [],
      tagOptions: [],
      cityOptions: [],
      pageOptions: [],
      hasDetailLevels: false,
      bonusList: [],
      userLevelsChecked: [],
      userTagsChecked: [],
      zoneChecked: [NATIONWIDE_ZONE],
      stockInfo: null,
      rewardItems: [],
      rewardErrorItems: [],
      originalAllStock: null,
      originalAllStockError: null,
      form: {
        title: '',
        title2: '',
        userLevels: '',
        userTags: '',
        userWw: 0,
        rule: '',
        startTime: null,
        endTime: null,
        dayStartTime: null,
        dayEndTime: null,
        isEnable: 0,
        imgUrl: '',
        imgUrl2: '',
        bgUrl: '',
        zone: '',
        tips: '',
        pwd: '',
        allStock: 0,
        dayStock: 0,
        allJoin: 0,
        dayJoin: 0,
        allStockError: 0,
        drawError: 0,
        jumpType: 0,
        linkurl: '',
        linkid: '',
        sort: 0
      },
      rules: {
        title: [{
          required: true,
          message: '请输入活动名称',
          trigger: 'blur'
        }],
        pwd: [{
          required: true,
          message: '请输入口令',
          trigger: 'blur'
        }],
        allStock: [{
          required: true,
          message: '请输入猜对奖励上限',
          trigger: 'blur'
        }]
      }
    };
  },
  computed: {
    isEdit: function isEdit() {
      return !!this.id;
    },
    crossDay: function crossDay() {
      return !!(this.form.dayStartTime && this.form.dayEndTime && this.form.dayStartTime > this.form.dayEndTime);
    },
    isLevelIndeterminate: function isLevelIndeterminate() {
      return this.userLevelsChecked.length > 0 && this.userLevelsChecked.length < this.gradeOptions.length;
    },
    isLevelAllChecked: function isLevelAllChecked() {
      return this.gradeOptions.length > 0 && this.userLevelsChecked.length === this.gradeOptions.length;
    },
    isNationwide: function isNationwide() {
      return this.zoneChecked.indexOf(NATIONWIDE_ZONE) !== -1;
    }
  },
  created: function created() {
    this.loadGradeOptions();
    this.loadTagOptions();
    this.loadCityOptions();
    this.loadBonusList();
    this.loadPageOptions();
    if (this.id) {
      this.fetchDetail();
    }
  },
  methods: {
    fetchDetail: function fetchDetail() {
      var _this2 = this;
      this.loading = true;
      (0, _cipher.getCipherDetail)(this.id).then(function (response) {
        var data = response.data;
        Object.keys(_this2.form).forEach(function (key) {
          if (data[key] !== undefined && data[key] !== null) {
            _this2.form[key] = data[key];
          }
        });
        _this2.originalAllStock = data.allStock;
        _this2.originalAllStockError = data.allStockError;
        if (data.startTime && data.endTime) {
          _this2.timeRange = [data.startTime, data.endTime];
        }

        // 每日时段兼容历史 HH:mm:ss 数据，统一截为 HH:mm
        if (_this2.form.dayStartTime) {
          _this2.form.dayStartTime = String(_this2.form.dayStartTime).slice(0, 5);
        }
        if (_this2.form.dayEndTime) {
          _this2.form.dayEndTime = String(_this2.form.dayEndTime).slice(0, 5);
        }
        if (data.userLevels) {
          _this2.hasDetailLevels = true;
          _this2.userLevelsChecked = data.userLevels.split(',').filter(Boolean).map(Number);
        }
        if (data.userTags) {
          _this2.userTagsChecked = data.userTags.split(',').filter(Boolean).map(Number);
        }
        if (data.zone) {
          _this2.zoneChecked = data.zone.split(',').filter(Boolean).map(Number);
        } else {
          // 未配置地区 = 全国
          _this2.zoneChecked = [NATIONWIDE_ZONE];
        }

        // 奖励明细按 type 拆两组
        var items = data.items || [];
        _this2.rewardItems = items.filter(function (i) {
          return i.type === 1;
        }).map(function (i) {
          return {
            typeId: i.typeId,
            num: i.num || 1
          };
        });
        _this2.rewardErrorItems = items.filter(function (i) {
          return i.type === 2;
        }).map(function (i) {
          return {
            typeId: i.typeId,
            num: i.num || 1
          };
        });

        // 库存统计（总库存/剩余库存）
        _this2.fetchStock();
        _this2.loading = false;
      }).catch(function () {
        _this2.loading = false;
      });
    },
    loadGradeOptions: function () {
      var _loadGradeOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var response, _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 1;
              return (0, _gradeInfo.xyRuleVipGradeSelPage)({
                page: 1,
                limit: 100
              });
            case 1:
              response = _context2.sent;
              if (response.code === 200 && response.records) {
                this.gradeOptions = response.records.map(function (item) {
                  return {
                    id: item.id,
                    name: item.name
                  };
                });
                // 初始默认全选（编辑时已保存过等级则以保存值为准）
                if (!this.hasDetailLevels) {
                  this.userLevelsChecked = this.gradeOptions.map(function (grade) {
                    return grade.id;
                  });
                }
              }
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              console.error('获取会员等级列表失败:', _t2);
            case 3:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[0, 2]]);
      }));
      function loadGradeOptions() {
        return _loadGradeOptions.apply(this, arguments);
      }
      return loadGradeOptions;
    }(),
    loadTagOptions: function () {
      var _loadTagOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var response, list, _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _context3.next = 1;
              return (0, _common.getMemberLabelCombo)();
            case 1:
              response = _context3.sent;
              list = response && response.data || response || []; // 数据来源 xy_users_label（label_id / label_name）
              this.tagOptions = (Array.isArray(list) ? list : []).map(function (item) {
                return {
                  id: item.labelId,
                  name: item.labelName
                };
              });
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              console.error('获取用户标签列表失败:', _t3);
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this, [[0, 2]]);
      }));
      function loadTagOptions() {
        return _loadTagOptions.apply(this, arguments);
      }
      return loadTagOptions;
    }(),
    loadPageOptions: function () {
      var _loadPageOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var response, list, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              _context4.next = 1;
              return (0, _popupConfig.queryPageList)();
            case 1:
              response = _context4.sent;
              list = response && response.data || response || [];
              this.pageOptions = (Array.isArray(list) ? list : []).filter(function (item) {
                return item.pageUrl;
              }).map(function (item) {
                return {
                  pageName: item.pageName,
                  pageUrl: item.pageUrl
                };
              });
              _context4.next = 3;
              break;
            case 2:
              _context4.prev = 2;
              _t4 = _context4["catch"](0);
              console.error('获取跳转页面列表失败:', _t4);
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[0, 2]]);
      }));
      function loadPageOptions() {
        return _loadPageOptions.apply(this, arguments);
      }
      return loadPageOptions;
    }(),
    loadCityOptions: function () {
      var _loadCityOptions = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var response, list, _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.prev = 0;
              _context5.next = 1;
              return (0, _shopList.getEffectiveCityList)({
                regionType: 2
              });
            case 1:
              response = _context5.sent;
              list = response && response.data || response || [];
              this.cityOptions = (Array.isArray(list) ? list : []).map(function (item) {
                return {
                  regionId: item.regionId !== undefined ? item.regionId : item.id,
                  regionName: item.regionName || item.name
                };
              });
              _context5.next = 3;
              break;
            case 2:
              _context5.prev = 2;
              _t5 = _context5["catch"](0);
              console.error('获取地区列表失败:', _t5);
            case 3:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[0, 2]]);
      }));
      function loadCityOptions() {
        return _loadCityOptions.apply(this, arguments);
      }
      return loadCityOptions;
    }(),
    loadBonusList: function () {
      var _loadBonusList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
        var response, _t6;
        return regeneratorRuntime.wrap(function (_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.prev = 0;
              _context6.next = 1;
              return (0, _lottery.getBonusList)();
            case 1:
              response = _context6.sent;
              if (response.code === 200 && response.data) {
                this.bonusList = response.data;
              }
              _context6.next = 3;
              break;
            case 2:
              _context6.prev = 2;
              _t6 = _context6["catch"](0);
              console.error('加载优惠券列表失败:', _t6);
            case 3:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function loadBonusList() {
        return _loadBonusList.apply(this, arguments);
      }
      return loadBonusList;
    }(),
    addRewardItem: function addRewardItem(list) {
      list.push({
        typeId: null,
        num: 1
      });
    },
    removeRewardItem: function removeRewardItem(list, index) {
      list.splice(index, 1);
    },
    handleCheckAllLevel: function handleCheckAllLevel(val) {
      this.userLevelsChecked = val ? this.gradeOptions.map(function (grade) {
        return grade.id;
      }) : [];
    },
    handleZoneChange: function handleZoneChange(val) {
      // 选择全国后，其他地区不需要且不可再选，之前选的全部清空
      if (val.indexOf(NATIONWIDE_ZONE) !== -1) {
        this.zoneChecked = [NATIONWIDE_ZONE];
      }
    },
    handleJumpTypeChange: function handleJumpTypeChange() {
      // 切换跳转类型后清空原配置，避免链接与页面地址混用
      this.form.linkurl = '';
      this.form.linkid = '';
    },
    fetchStock: function fetchStock() {
      var _this3 = this;
      (0, _cipher.getCipherStock)(this.id).then(function (response) {
        _this3.stockInfo = response.data;
      }).catch(function () {});
    },
    handleSubmit: function handleSubmit() {
      var _this4 = this;
      this.$refs.formRef.validate(/*#__PURE__*/function () {
        var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee7(valid) {
          var validItems, validErrorItems, formData, items, _t7;
          return regeneratorRuntime.wrap(function (_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                if (valid) {
                  _context7.next = 1;
                  break;
                }
                return _context7.abrupt("return");
              case 1:
                if (!(!_this4.timeRange || _this4.timeRange.length !== 2)) {
                  _context7.next = 2;
                  break;
                }
                _this4.$message.error('请选择活动时间');
                return _context7.abrupt("return");
              case 2:
                // 过滤未选择优惠券的空行
                validItems = _this4.rewardItems.filter(function (i) {
                  return i.typeId;
                });
                validErrorItems = _this4.rewardErrorItems.filter(function (i) {
                  return i.typeId;
                });
                if (!(validItems.length === 0)) {
                  _context7.next = 3;
                  break;
                }
                _this4.$message.error('请至少配置一条猜对奖励');
                return _context7.abrupt("return");
              case 3:
                if (!_this4.isEdit) {
                  _context7.next = 5;
                  break;
                }
                if (!(_this4.form.allStock != null && _this4.originalAllStock != null && _this4.form.allStock < _this4.originalAllStock)) {
                  _context7.next = 4;
                  break;
                }
                _this4.$message.error('猜对奖励上限只能增加不能减少');
                return _context7.abrupt("return");
              case 4:
                if (!(_this4.form.allStockError != null && _this4.originalAllStockError != null && _this4.form.allStockError < _this4.originalAllStockError)) {
                  _context7.next = 5;
                  break;
                }
                _this4.$message.error('猜错奖励上限只能增加不能减少');
                return _context7.abrupt("return");
              case 5:
                formData = _objectSpread({}, _this4.form);
                formData.startTime = _this4.timeRange[0];
                formData.endTime = _this4.timeRange[1];

                // 资格限制：逗号分隔，空=不限
                formData.userLevels = (0, _toConsumableArray2.default)(_this4.userLevelsChecked).sort(function (a, b) {
                  return a - b;
                }).join(',');
                formData.userTags = (0, _toConsumableArray2.default)(_this4.userTagsChecked).sort(function (a, b) {
                  return a - b;
                }).join(',');
                formData.zone = (0, _toConsumableArray2.default)(_this4.zoneChecked).filter(function (v) {
                  return v !== NATIONWIDE_ZONE;
                }).sort(function (a, b) {
                  return a - b;
                }).join(',');

                // 组装奖励明细
                items = [];
                validItems.forEach(function (i) {
                  return items.push({
                    type: 1,
                    typeId: i.typeId,
                    num: i.num
                  });
                });
                validErrorItems.forEach(function (i) {
                  return items.push({
                    type: 2,
                    typeId: i.typeId,
                    num: i.num
                  });
                });
                formData.items = items;
                if (_this4.id) {
                  formData.id = _this4.id;
                }
                _this4.loading = true;
                _context7.prev = 6;
                _context7.next = 7;
                return (0, _cipher.saveCipher)(formData);
              case 7:
                _this4.$message.success('保存成功');
                _this4.$emit('success');
                _context7.next = 9;
                break;
              case 8:
                _context7.prev = 8;
                _t7 = _context7["catch"](6);
                console.error('保存失败:', _t7);
              case 9:
                _context7.prev = 9;
                _this4.loading = false;
                return _context7.finish(9);
              case 10:
              case "end":
                return _context7.stop();
            }
          }, _callee7, null, [[6, 8, 9, 10]]);
        }));
        return function (_x2) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    handleCancel: function handleCancel() {
      this.$emit('cancel');
    }
  }
};